<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Entrada"
    >
        <div v-if="model">
            <rkm-alert
                v-if="additionals.allowUpdate && additionals.hasPendencias"
                class="mb-2"
                color="warning"
            >
                Existem pendências de vínculos para poder aprovar a entrada.
            </rkm-alert>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Almoxarifado"
                        v-model="model.unidadeNome"
                    >
                        <rkm-input-group-append
                            v-if="additionals.allowUpdate && model.isCentroCustoConectasusPendente"
                            slot="append"
                        >
                            <rkm-button
                                @click="$refs.ModalVinculoConectaSusCentroCusto.open(model.unidadeId)"
                                authorize="edit-web-service-almoxarifado-cliente-unidade"
                                color="primary"
                            >
                                Vincular centro de custo
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Fornecedor"
                        v-model="model.fornecedorNome"
                    >
                        <rkm-input-group-append
                            v-if="additionals.allowUpdate && model.isFornecedorConectasusPendente"
                            slot="append"
                        >
                            <rkm-button
                                @click="$refs.ModalVinculoConectaSusFornecedor.open(model.fornecedorId)"
                                authorize="edit-web-service-almoxarifado-cliente-fornecedor"
                                color="primary"
                            >
                                Vincular fornecedor
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        disabled
                        label="Código da nota"
                        v-model="model.codigoNota"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        disabled
                        label="Tipo de documento"
                        v-model="model.documentoTipoNome"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        disabled
                        label="Data do documento"
                        v-model="model.dataDocumento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        disabled
                        label="Número do documento"
                        v-model="model.numeroDocumento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        disabled
                        label="Número do pedido"
                        v-model="model.numeroPedido"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        disabled
                        label="Status"
                        v-model="model.statusNome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-area title="Materiais">
                        <rkm-table
                            :fields="fields.itens"
                            :items="model.itens"
                            hide-filters
                        >
                            <template v-slot:cell(pendencias)="{item}">

                                <div v-if="additionals.allowUpdate
                                    && !item.isMaterialConectasusPendente
                                    && item.isMaterialConectasusParametrizacaoControleEstoquePendente"
                                >
                                    Parametrizar o grupo/subgrupo no almoxarifado.
                                </div>

                                <div v-if="additionals.allowUpdate && item.isMaterialConectasusPendente">
                                    <rkm-button
                                        @click="$refs.ModalVinculoConectaSusMaterial.open(item.materialId)"
                                        authorize="edit-web-service-almoxarifado-cliente-material"
                                        block
                                        class="my-1"
                                        color="primary"
                                        small
                                    >
                                        Vincular material
                                    </rkm-button>
                                </div>

                                <div v-if="additionals.allowUpdate && item.isFabricanteConectasusPendente">
                                    <rkm-button
                                        @click="$refs.ModalVinculoConectaSusFabricante.open(item.fabricanteId)"
                                        authorize="edit-web-service-almoxarifado-cliente-fabricante"
                                        block
                                        class="my-1"
                                        color="primary"
                                        small
                                    >
                                        Vincular fabricante
                                    </rkm-button>
                                </div>
                            </template>
                        </rkm-table>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </div>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <template v-if="additionals && additionals.allowUpdate">
                <rkm-button
                    @click="confirmReject"
                    color="danger"
                >
                    Recusar
                </rkm-button>

                <rkm-button
                    :disabled="additionals.hasPendencias"
                    @click="confirmApprove"
                    color="success"
                >
                    Aprovar
                </rkm-button>
            </template>
        </template>

        <ModalVinculoConectaSusFabricante
            @saved="load"
            ref="ModalVinculoConectaSusFabricante"
        />

        <ModalVinculoConectaSusFornecedor
            @saved="load"
            ref="ModalVinculoConectaSusFornecedor"
        />

        <ModalVinculoConectaSusMaterial
            @saved="load"
            ref="ModalVinculoConectaSusMaterial"
        />

        <ModalVinculoConectaSusCentroCusto
            @saved="load"
            ref="ModalVinculoConectaSusCentroCusto"
        />
    </rkm-modal>
</template>

<script>
// Components.
import ModalVinculoConectaSusFabricante from '@/components/web-service/almoxarifado/cliente/fabricante/components/vinculo-conecta-sus-fabricante/Modal'
import ModalVinculoConectaSusFornecedor from '@/components/web-service/almoxarifado/cliente/fornecedor/components/vinculo-conecta-sus-fornecedor/Modal'
import ModalVinculoConectaSusMaterial from '@/components/web-service/almoxarifado/cliente/material/components/vinculo-conecta-sus-material/Modal'
import ModalVinculoConectaSusCentroCusto from '@/components/web-service/almoxarifado/cliente/unidade/components/vinculo-conecta-sus-centro-custo/Modal'

// Mixins.
import {error, repository, formats} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        ModalVinculoConectaSusFabricante,
        ModalVinculoConectaSusFornecedor,
        ModalVinculoConectaSusMaterial,
        ModalVinculoConectaSusCentroCusto,
    },
    computed: {
        fields() {
            const itens = [
                {key: 'materialNome', label: 'Material', sortable: true},
                {key: 'lote', label: 'Lote', class: 'col-min text-center', sortable: true},
                {key: 'validadeLote', label: 'Validade do lote', formatter: v => this.formatDate(v), class: 'col-min text-center', sortable: true},
                {key: 'valorUnitario', label: 'Valor unitário', class: 'col-min text-center', sortable: true},
                {key: 'quantidade', label: 'Quantidade', class: 'col-min text-center', sortable: true},
                {key: 'fabricanteNome', label: 'Fabricante', sortable: true},
            ]

            if (this.additionals.allowUpdate && this.additionals.hasPendenciasMateriais) {

                itens.push({key: 'pendencias', label: 'Pendências', class: 'col-min text-center'})
            }

            return {itens}
        },
    },
    created() {
        this.repositories = {
            aprovacaoEntrada: this.getConectaSusRepository('webService.almoxarifado.cliente.aprovacaoEntrada'),
        }
    },
    data: () => ({
        entradaId: null,
        additionals: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(entradaId) {
            this.entradaId = entradaId
            this.additionals = null
            this.model = null

            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            this.setLoading()

            this.repositories.aprovacaoEntrada.edit(this.entradaId)
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        confirmApprove() {

            this.showConfirmation('Deseja realmente aprovar a entrada?', this.approve)
        },
        async approve() {
            this.setLoading()

            this.repositories.aprovacaoEntrada.approve(this.entradaId)
                .then(() => {
                    this.showSaveNotification()
                    this.$refs.RkmModal.hide()
                    this.$emit('saved')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        confirmReject() {

            this.showConfirmation('Deseja realmente recusar a entrada?', this.reject)
        },
        async reject() {
            this.setLoading()

            this.repositories.aprovacaoEntrada.reject(this.entradaId)
                .then(() => {
                    this.showSaveNotification()
                    this.$refs.RkmModal.hide()
                    this.$emit('saved')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, formats],
}
</script>